import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private router: Router) {}
 
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const adminId = localStorage.getItem('adminId');
    if (state.url.startsWith('/omnidashboard') && (adminId === null || adminId === undefined)) {
      this.router.navigate(['/di-home']);
      return false;
    }
    if(adminId===null || adminId === undefined){
      return true;
    }
    else if(state.url === '/erg-admin-home' && (adminId.includes('1') || adminId==='1')) {
      return true;
    }else if(state.url.startsWith('/omnidashboard') && (adminId.includes('1') || adminId==='1')) {
      return true;
    }else if(state.url === '/di-home' && (adminId !== '1')){
      return true;
    }else{
      this.router.navigate(['/di-home']);
      return false;
    }
  }
  
}
